import { useModal } from "@/hooks/modals/useModal";
import type { FormInstance } from "antd";
import { useEffect } from "react";
import type { BlockApplyFormFields } from "../type";
import type { SupplierBlockItemDetail } from "@/types/apis";
import { getFileName } from "@/utils/file";

export function useInitFormFields(
  form: FormInstance<BlockApplyFormFields>,
  detail?: SupplierBlockItemDetail,
) {
  const { props, open } = useModal("MATERIAL_BLOCK");
  const { supplier } = props;
  useEffect(() => {
    if (!open) return;
    if (supplier) {
      form.setFieldsValue({
        supplierCode: supplier.supplierCode,
        supplierUserName: supplier.supplierName,
        supplierUsUserName: supplier.supplierUsName,
      });
    }

    if (detail) {
      form.setFieldsValue({
        supplierCode: detail.supplierCode,
        supplierUserName: detail.supplierUserName,
        supplierUsUserName: detail.supplierUsUserName,
        blockReason: detail.blockReason,
        unblockReason: detail.unblockReason,
        blockType: detail.blockType,
        blockedFactoryNames: detail.blockedFactoryNames,
        blockedFactoryValues: detail.blockedFactoryValues.split(","),
        blockedMaterialNames: detail.blockedMaterialNames,
        blockedMaterialValues: detail.blockedMaterialValues.split(","),
        files: detail.srmSupplierFlowBusinessFiles.map((f) => ({
          uid: f.id.toString(),
          url: f.fileUrl,
          name: getFileName(f.fileUrl),
        })),
      });
    }
  }, [open, form, supplier, detail]);
}
